<template>
  <div class="i-payment-table">
    <div class="heading">
      Take a <strong>shortcut</strong> to the most fulfilling & <strong>profitable</strong> years of your career
    </div>
    <div class="pre-sub">Invest in yourself & enjoy lifelong career success</div>
    <div class="points">
      <div class="point">
        <img :src="iconSecure" />
        <div class="text">Secure <span>End-to-end encryption</span></div>
      </div>
      <div class="point">
        <img :src="iconGuarantee" />
        <div class="text">Guarantee <span>30-day money back</span></div>
      </div>
      <div class="point">
        <img :src="iconSupport" />
        <div class="text">24/7 Support <span>Any issues resolved</span></div>
      </div>
    </div>
    <div class="sub">Unlimited access with a flexible subscription — cancel anytime</div>
    <div
      ref="paymentTableRef"
      class="wrapper"
    >
      <template v-if="isXlOrLarger">
        <div
          id="plan-section"
          class="plan-wrapper"
        >
          <template
            v-for="card in PAYMENT_DETAILS"
            :key="card.type"
          >
            <div class="main">
              <div
                class="plan"
                :class="{ active: card.type === 'Quarterly' }"
              >
                <div class="inner">
                  <div class="top">
                    <div class="first">
                      <div class="info">
                        {{ card.type }}
                        <div
                          v-if="card.type === 'Quarterly'"
                          class="badge"
                        >
                          <div class="most-popular">Most Popular</div>
                        </div>
                      </div>
                      <img
                        v-if="card.type === 'Quarterly'"
                        class="radio"
                        :src="iconFilledRadio"
                      />
                    </div>
                    <div class="price">{{ card.price }}/month</div>
                    <div class="per-day">{{ card.perDay }} per day</div>
                  </div>
                  <div class="list">
                    <ul>
                      <li class="item"><img :src="card.icon" />Top 10 Career Paths</li>
                      <li class="item"><img :src="card.icon" />Detailed Personality Types & Insights</li>
                      <li class="item"><img :src="card.icon" />Tailored Career Strategy</li>
                      <li class="item"><img :src="card.icon" />Unlimited Quiz Retakes</li>
                      <li class="item"><img :src="card.icon" />Resume & LinkedIn Optimization</li>
                      <li class="item"><img :src="card.icon" />Personalized Job Board</li>
                      <li class="item"><img :src="card.icon" />Job Opening Alerts</li>
                      <li class="item"><img :src="card.icon" />Weekly Live Career Coaching</li>
                      <li class="item"><img :src="card.icon" />2 Hours of Coaching per Month</li>
                    </ul>
                    <div
                      class="footnote"
                      v-html="card.footnote"
                    ></div>
                  </div>
                </div>
              </div>
              <iBaseButton
                v-bind="BUTTON_STYLE"
                :background-color="card.color"
                :is-disabled="isPaymentButtonDisabled"
                :icon-url="iconArrowRight"
                icon-width="22px"
                @clicked="firePaymentAction(card.stripePrice)"
              />
            </div>
          </template>
        </div>
      </template>
      <template v-else>
        <div
          class="tabs"
          :style="{ '--ac-color': PAYMENT_DETAILS[currentSlide].color }"
        >
          <div
            class="tab"
            :class="{ active: currentSlide == 0 }"
            @click="slideTo(0)"
          >
            Monthly
          </div>
          <div
            class="tab"
            :class="{ active: currentSlide == 1 }"
            @click="slideTo(1)"
          >
            Quarterly
          </div>
          <div
            class="tab"
            :class="{ active: currentSlide == 2 }"
            @click="slideTo(2)"
          >
            Annually
          </div>
        </div>
        <Carousel
          ref="pricingCarousel"
          :autoplay="0"
          :items-to-scroll="1"
          :items-to-show="
            screenWidth / (isDesktopOrLarger ? 500 : isTabletOrLarger ? 450 : isMobileOrLarger ? 470 : 370)
          "
          class="payment-carousel"
          snap-align="start"
        >
          <Slide
            v-for="card in PAYMENT_DETAILS"
            :key="card.type"
          >
            <div class="main">
              <div
                class="plan"
                :class="{ active: card.type === 'Quarterly' }"
              >
                <div class="inner">
                  <div class="top">
                    <div class="first">
                      <div class="info">
                        {{ card.type }}
                        <div
                          v-if="card.type === 'Quarterly'"
                          class="badge"
                        >
                          <div class="most-popular">Most Popular</div>
                        </div>
                      </div>
                      <img
                        v-if="card.type === 'Quarterly'"
                        class="radio"
                        :src="iconFilledRadio"
                      />
                    </div>
                    <div class="price">{{ card.price }}/month</div>
                    <div class="per-day">{{ card.perDay }} per day</div>
                  </div>
                  <div class="list">
                    <ul>
                      <li class="item"><img :src="card.icon" />Top 10 Career Paths</li>
                      <li class="item"><img :src="card.icon" />Detailed Personality Types & Insights</li>
                      <li class="item"><img :src="card.icon" />Tailored Career Strategy</li>
                      <li class="item"><img :src="card.icon" />Unlimited Quiz Retakes</li>
                      <li class="item"><img :src="card.icon" />Resume & LinkedIn Optimization</li>
                      <li class="item"><img :src="card.icon" />Personalized Job Board</li>
                      <li class="item"><img :src="card.icon" />Job Opening Alerts</li>
                      <li class="item"><img :src="card.icon" />Weekly Live Career Coaching</li>
                      <li class="item"><img :src="card.icon" />2 Hours of Coaching per Month</li>
                    </ul>
                    <div
                      class="footnote"
                      v-html="card.footnote"
                    ></div>
                  </div>
                </div>
              </div>
              <iBaseButton
                v-bind="BUTTON_STYLE"
                :background-color="card.color"
                :is-disabled="isPaymentButtonDisabled"
                :icon-url="iconArrowRight"
                icon-width="22px"
                @clicked="firePaymentAction(card.stripePrice)"
              />
            </div>
          </Slide>
        </Carousel>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue"
import { useRoute, useRouter } from "vue-router"
import { Carousel, Slide } from "vue3-carousel"
import { useUserStore } from "@/stores/user"
import { white } from "@/styles/colors"
import { breakpointLg, breakpointMd, breakpointSm, breakpointXl } from "@/styles/variables"

import getPaymentAction from "@/composables/getPaymentAction"
import useIsScreenSize from "@/composables/useIsScreenSize"
import useScreenSize from "@/composables/useScreenSize"
import useRandomNumber from "@/composables/useRandomNumber"
import { GlobalVariables } from "@/helpers/globalVariables"
import api from "@/services/apiClient"
import GtmService, { UserFlow } from "@/services/gtmService"

// COMPONENTS
import iBaseButton from "@/components/base/BaseButton.vue"

// ASSETS
import iconFilledRadio from "@/assets/icons/icon-filled-radio.svg"
import iconCheckBlue from "@/assets/icons/icon-check-bluey.svg"
import iconCheckCyan from "@/assets/icons/icon-check-cyan.svg"
import iconCheckPink from "@/assets/icons/icon-check-pink.svg"
import iconSecure from "@/assets/icons/icon-secure.svg"
import iconGuarantee from "@/assets/icons/icon-guarantee.svg"
import iconSupport from "@/assets/icons/icon-support.svg"
import iconArrowRight from "@/assets/icons/icon-arrow-right-white.svg"

// TYPES
import StripePrice from "@/shared/enums/StripePrice"
import { Price } from "@/shared/types/Price"
import { CheckoutSessionItem } from "@/shared/types/CheckoutSession"

// STORES AND ROUTES
const userStore = useUserStore()
const activeRoute = useRoute()
const router = useRouter()

// COMPOSABLES
const isMobileOrLarger = useIsScreenSize(breakpointSm)
const isTabletOrLarger = useIsScreenSize(breakpointMd)
const isDesktopOrLarger = useIsScreenSize(breakpointLg)
const isXlOrLarger = useIsScreenSize(breakpointXl)
const screenWidth = useScreenSize()
const quarterlyReportPurchases = useRandomNumber(userStore.getFullName || "Full Name", 200, 310)
const annualReportPurchases = useRandomNumber(userStore.getFullName || "Full Name", 90, 170)

// CONSTANTS
const PAYMENT_DETAILS = [
  {
    color: "#47D9C3",
    type: "Monthly",
    price: "$29.99",
    perDay: "$0.99",
    icon: iconCheckCyan,
    stripePrice: StripePrice.REPORT_MONTHLY
  },
  {
    color: "#BB51FF",
    type: "Quarterly",
    price: "$19.99",
    perDay: "$0.66",
    icon: iconCheckPink,
    key: "Most Popular",
    footnote: `<strong>${quarterlyReportPurchases.value} people</strong> purchased in the <strong>last 24 hours</strong>`,
    stripePrice: StripePrice.REPORT_QUARTERLY
  },
  {
    color: "#4F99FF",
    type: "Annually",
    price: "$9.99",
    perDay: "$0.33",
    icon: iconCheckBlue,
    key: "Best Value",
    footnote: `<strong>${annualReportPurchases.value} people</strong> purchased recently`,
    stripePrice: StripePrice.REPORT_ANNUAL
  }
]
const BUTTON_STYLE = {
  text: "Subscribe Today",
  borderRadius: "8px",
  fontWeight: "500",
  textColor: white,
  width: "100%",
  padding: "10px 25px",
  size: "medium"
}

// COMPUTED
const isDiscoverPage = computed(() => activeRoute.name === GlobalVariables.urls.discover.routeName)

// FUNCTIONS
const disablePaymentButtons = () => {
  isPaymentButtonDisabled.value = true
}

const enablePaymentButtons = () => {
  isPaymentButtonDisabled.value = false
}

const slideTo = (index: number) => {
  if (pricingCarousel.value) {
    pricingCarousel.value.slideTo(index, false)
    currentSlide.value = index
  } else return
}

const firePaymentAction = async (stripePrice: StripePrice) => {
  if (isPaymentButtonDisabled.value) return
  disablePaymentButtons()
  if (isDiscoverPage.value) {
    router.push({ name: GlobalVariables.urls.report.children.checkout.routeName, query: { uuid: stripePrice } })
  } else {
    try {
      await getPaymentAction([stripePrice], UserFlow.REPORT, enablePaymentButtons)()
    } catch {
      enablePaymentButtons()
    }
  }
}

/**
 * Fetch the prices and their information from the API
 */
const fetchPrices = async () => {
  try {
    const response = await api.stripe.getPrices([
      StripePrice.REPORT_MONTHLY,
      StripePrice.REPORT_QUARTERLY,
      StripePrice.REPORT_ANNUAL
    ])
    const pricesArr = response.prices
    prices.value = {
      monthly: pricesArr.find((p) => p.uuid === StripePrice.REPORT_MONTHLY) || null,
      quarterly: pricesArr.find((p) => p.uuid === StripePrice.REPORT_QUARTERLY) || null,
      annual: pricesArr.find((p) => p.uuid === StripePrice.REPORT_ANNUAL) || null
    }
  } catch (error) {
    console.error("Failed to load prices", error)
  }
}

const sendGTMEvent = async () => {
  const items: CheckoutSessionItem[] = []

  if (prices.value.monthly) {
    items.push({
      id: prices.value.monthly.productId,
      name: prices.value.monthly.name,
      price: prices.value.monthly.price / 100,
      quantity: 1
    })
  }

  if (prices.value.quarterly) {
    items.push({
      id: prices.value.quarterly.productId,
      name: prices.value.quarterly.name,
      price: prices.value.quarterly.price / 100,
      quantity: 1
    })
  }

  if (prices.value.annual) {
    items.push({
      id: prices.value.annual.productId,
      name: prices.value.annual.name,
      price: prices.value.annual.price / 100,
      quantity: 1
    })
  }

  await GtmService.viewItemListEvent(UserFlow.REPORT, items)
}

// REFS
/**
 * Prices for the different report types. Fetched from the API.
 */
const prices = ref<Record<"monthly" | "quarterly" | "annual", Price | null>>({
  monthly: null,
  quarterly: null,
  annual: null
})

const pricingCarousel = ref<typeof Carousel | null>(null)
const currentSlide = ref<number>(0)

/**
 * Whether the payment buttons should be disabled
 * - We want to disable this when the user is already in the process of starting a checkout session
 */
const isPaymentButtonDisabled = ref(false)

const paymentTableRef = ref<HTMLElement | null>(null)

// LIFECYCLE
onMounted(() => {
  fetchPrices().then(() => {
    enablePaymentButtons()
  })

  // Send GTM event when the payment table is in view
  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          sendGTMEvent()
          obs.disconnect() // trigger only once
        }
      })
    },
    { threshold: 0.1 }
  )
  if (paymentTableRef.value) observer.observe(paymentTableRef.value)
})
</script>

<style lang="scss" scoped>
.i-payment-table {
  @include flex(column, center, center, $gap: 30px);

  .heading {
    @include display-md;

    text-align: center;
    font-weight: 300px;
    max-width: 640px;
    font-style: italic;
  }

  .pre-sub {
    @include display-xs;

    text-align: center;
    font-weight: 200px;
    font-style: italic;
  }

  .points {
    @include flex(column, center, stretch, $gap: 15px);

    font-weight: 300;
    margin: 20px auto;

    @media screen and (min-width: $breakpoint-lg) {
      @include flex(row, center, stretch, $gap: 40px);
    }

    .point {
      @include flex(row, start, center, $gap: 12px);
      @include border-radius-md;
      @include text-md;

      font-weight: 300;
      background-color: $white;
      box-shadow: 0 4px 16px 0 $black100;
      padding: 14px 18px;

      .text {
        @include flex(column, start, start);
        @include text-lg;

        span {
          @include text-sm;
        }
      }
    }
  }

  .sub {
    @include display-xs;

    text-align: center;
    font-weight: 200px;
  }

  .wrapper {
    @include flex(column, center, center, $gap: 20px);

    width: 100%;

    .tabs {
      @include flex(row, center, center);
      @include border-radius-sm;

      overflow: hidden;

      .tab {
        @include text-sm;

        font-weight: 600;
        color: $black100;
        background-color: black;
        cursor: pointer;
        padding: 15px 16px;

        &:not(:last-child) {
          border-right: 1px solid $black800;
        }

        &.active {
          background-color: var(--ac-color);
          color: $black;
        }
      }
    }

    .payment-carousel {
      width: 100%;
    }
  }

  .plan-wrapper {
    @include flex(row, center, stretch, $gap: 18px);
  }

  .main {
    @include flex(column, start, center, $gap: 8px);

    height: 100%;

    @media screen and (min-width: $breakpoint-md) {
      gap: 12px;
    }

    @media screen and (min-width: $breakpoint-xl) {
      height: unset;
    }

    .plan {
      @include border-radius-lg;

      height: 100%;
      width: 320px;
      border: 1px solid $zumthor100;
      background-color: $white;
      padding: 4px;
      text-align: start;

      @media screen and (min-width: $breakpoint-sm) {
        width: 372px;
      }

      @media screen and (min-width: $breakpoint-xl) {
        width: 100%;
        max-width: 372px;
      }

      .inner {
        @include flex(column, start, stretch);

        height: 100%;

        > div {
          padding: 12px;

          @media screen and (min-width: $breakpoint-md) {
            padding: 20px;
          }
        }

        .top {
          @include flex(column, start, stretch);

          .first {
            @include flex(row, space-between, start, $gap: 6px);

            .info {
              @include flex(row, start, center, $gap: 8px);
              @include text-lg;

              font-weight: 600;

              .badge {
                @include border-radius-xxl;
                @include text-xs;

                text-transform: uppercase;
                width: fit-content;
                background-image: $blue-purple-gradient;
                font-weight: 700;

                .most-popular {
                  @include border-radius-xxl;

                  padding: 4px 8px;
                  background-color: #ffffffda;
                  mix-blend-mode: screen;
                }
              }
            }

            .radio {
              width: 20px;
              flex: 0 0 20px;
            }
          }

          .price {
            @include flex(row, start, center, $gap: 6px);
            @include text-sm;

            font-weight: 400;
            color: $comet700;
          }

          .per-day {
            @include text-lg;

            font-weight: 500;
            margin-top: 10px;
          }
        }

        .list {
          @include flex(column, start, stretch, $gap: 15px);

          border-top: 1px solid $zumthor100;

          ul {
            margin: 0;
            padding-left: 0;

            .item {
              @include flex(row, start, center, $gap: 10px);
              @include text-sm;

              &:not(:last-child) {
                padding-bottom: 6px;
                border-bottom: 1px solid $zumthor100;
              }

              &:not(:first-child) {
                padding-top: 6px;
              }

              @media screen and (min-width: $breakpoint-md) {
                @include text-md;
              }

              @media screen and (min-width: $breakpoint-md) {
                &:not(:last-child) {
                  padding-bottom: 8px;
                }

                &:not(:first-child) {
                  padding-top: 8px;
                }
              }
            }
          }

          .footnote {
            @include text-xs;

            color: $amethyst600;

            @media screen and (min-width: $breakpoint-sm) {
              @include text-sm;
            }
          }
        }
      }

      &.active {
        background-image: $blue-purple-gradient;

        .inner {
          border-radius: 20px;
          background-color: white;
        }
      }
    }
  }
}
</style>
